import Swiper from 'swiper';
import { Autoplay, Keyboard, Mousewheel, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const swiperActualites = document.getElementsByClassName('swiper-actualites');

if(swiperActualites) {
	new Swiper('.swiper-actualites', {
		modules: [Autoplay, Keyboard, Mousewheel, Navigation],

		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
			stopOnLastSlide: false,
		},
		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		lazy: true,
		loop: true,
		mousewheel: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		nextSlideMessage: 'Suivant',
		prevSlideMessage: 'Précédent',
		slidesPerView: 1,
		spaceBetween: 12,

		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			984: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
		},
	});
}

const swiperImages = document.getElementsByClassName('swiper-images');

if(swiperImages) {
	new Swiper('.swiper-images', {
		modules: [Autoplay, Keyboard, Mousewheel, Navigation],

		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
			stopOnLastSlide: false,
		},
		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		lazy: true,
		loop: true,
		mousewheel: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		nextSlideMessage: 'Suivant',
		prevSlideMessage: 'Précédent',
		slidesPerView: 1,
		spaceBetween: 12,

		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			984: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
		},
	});
}

const swiperTexte = document.getElementsByClassName('swiper-texte');

if(swiperTexte) {
	new Swiper('.swiper-texte', {
		modules: [Keyboard, Mousewheel, Navigation],

		grabCursor: true,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		loop: true,
		mousewheel: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		nextSlideMessage: 'Suivant',
		prevSlideMessage: 'Précédent',
		slidesPerView: 1,
		spaceBetween: 0,
	});
}